import { AppStoreAdminCampaign } from './store.admin-campaign';

export const appStoreAdminCampaignIS: AppStoreAdminCampaign = {
  activeCampaigns: [],
  currentCampaign: {
    resolution: 96,
  },
};
